import React from 'react';

import { Switch, Route } from 'react-router-dom';
import Story from '../components/Story';
import Reels from '../components/Reels';
import Foto from '../components/Foto';
import { Feed } from '../components/Feed';
import Error from '../components/Error';
import '../App.css';
import '../components/Styles/commonStyles.css';
import Video from '../components/Video';
import { Home } from '../components/Home';

export const FEED = '/ferramentas/baixar-foto-perfil-instagram';
export const STORY = '/ferramentas/baixar-story-instagram';
export const REELS = '/ferramentas/baixar-reels-instagram';
export const FOTO = '/ferramentas/baixar-foto-instagram';
export const VIDEO = '/ferramentas/baixar-video-instagram';
export const HOME = '/ferramentas';

export function Routes() {
  return (
    <>
      <Route exact path={`${FEED}/`} component={Feed} />
      <Route exact path={`${HOME}/`} component={Home} />
      <Route exact path={`${STORY}/`} component={Story} />
      <Route exact path={`${VIDEO}/`} component={Video} />
      <Route exact path={`${REELS}/`} component={Reels} />
      <Route exact path={`${FOTO}/`} component={Foto} />
      <Route component={Error} />
    </>
  );
}
